import { z } from "zod";

// Define the schema with validations
export const numberSerieSchema = z.object({
  from: z.string().min(1),
  to: z.string().min(1),
  current: z.string().min(1),
})
.refine((data) => data.to === "" || data.from === "" || parseInt(data.from) < parseInt(data.to), {
  message: "numberSeries.fromGreaterThanTo",
  path: ['from'], // This targets the "from" field for the error
})
.refine((data) => data.current === "" || data.from === "" || parseInt(data.current) >= parseInt(data.from), {
  message: "numberSeries.currentLessThanFrom",
  path: ['current'], // This targets the "from" field for the error
})
.refine((data) => data.current === "" || data.to === "" || parseInt(data.current) <= parseInt(data.to), {
  message: "numberSeries.currentGreaterThanTo",
  path: ['current'], // This targets the "current" field for the error
});

export type NumberSerieype = z.infer<typeof numberSerieSchema>;